<template>
  <v-card class="tab-card bg-dot-img">
    <v-tabs
      v-model="tab"
    >
     <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="tabs-box" >
          Home Loan
      </v-tab>

      <v-tab href="#tab-2" class="tabs-box">
          Personal Loan
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box">
          Student Loan

      </v-tab>

      <v-tab href="#tab-4" class="tabs-box" >
          Car Loan
      </v-tab>

      <v-tab href="#tab-5" class="tabs-box">
          Policy Loan
      </v-tab>

      <v-tab href="#tab-6" class="tabs-box">
        Overdraft

      </v-tab>

      <v-tab href="#tab-7" class="tabs-box" >
        Consumer Loan
      </v-tab>

      <v-tab href="#tab-8" class="tabs-box">
        Loan Against Property
      </v-tab>

      <v-tab href="#tab-9" class="tabs-box">
       2-Wheeler Loan

      </v-tab>
      <v-tab href="#tab-10" class="tabs-box">
      Credit Card Loan

      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item
        value="tab-1"
        
      >
        <homeLoanList />
          
      </v-tab-item>
      <v-tab-item
        value="tab-2"
        
      >
        <personalLoanList />
        
      </v-tab-item>

      <v-tab-item
        value="tab-3"
        
      >
    
       <StudentLoanList />

      </v-tab-item>

      <v-tab-item
       value="tab-4"
      >
      <CarLoanList />
      </v-tab-item>

      <v-tab-item
         value="tab-5"
      >
         <PolicyLoanList />
      </v-tab-item>

      <v-tab-item
        value="tab-6"
      >
       <OverdraftList />
      </v-tab-item>

      <v-tab-item
        value="tab-7"
      >
       <ConsumerLoanList />
      </v-tab-item>

      <v-tab-item
        value="tab-8"
      >
        <ListLoanAgainstProperty />
        
      </v-tab-item>

      <v-tab-item
        value="tab-9"
      >
       <TwoWheelerLoanList />
      </v-tab-item>

      <v-tab-item
         value="tab-10"
      >
      <CreditCardList />
      
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

  import homeLoanList from './homeloan/homeLoanList'; 
  import personalLoanList from './personalLoan/personalLoanList';
  import ConsumerLoanList from './consumerLoan/ConsumerLoanList';
  import StudentLoanList from './studentLoan/StudentLoanList';
  import CarLoanList from './carLoan/CarLoanList';
  import TwoWheelerLoanList from './twoWheelerLoan/TwoWheelerLoanList'; 
  import OverdraftList from './overdraft/OverdraftList';
  import PolicyLoanList from './policyLoan/PolicyLoanList';
  import ListLoanAgainstProperty from './LoanAgainstProperty/ListLoanAgainstProperty';
  import CreditCardList from './creditCardLoan/CreditCardList';
  export default {
    components: {
     homeLoanList,
     personalLoanList,
     ConsumerLoanList,
     StudentLoanList,
     CarLoanList,
     TwoWheelerLoanList,
     OverdraftList,
     PolicyLoanList,
     ListLoanAgainstProperty,
     CreditCardList,
        },
    data () {
      return {
        tab: this.$route.params.tab,
        text: '',
        tabName: '',
      }
    },
    beforeCreate(){
    },
    methods:{
      CheckTab(tabName)
      {
        //this.tabName = tabName;;
      }
    },
  }
</script>